<template>
  <div :class="{'h-100':pageWhite}" class="bg-grey" 
  :style="($route.name=='formEditScreen' && typeof setPercent != 'undefined' && setPercent != null && setPercent == 100)?'padding-bottom: 100px;':''">
  
    <div class="headPage is-flex is-align-center" :class="widthMax < 1024 ?'navbar is-fixed-top':''">
      <div class="container" :style=" widthMax < 1024 ? 'display: flex;justify-content: center;align-items: center;':''">
        <div class="columns is-align-center is-marginless	">
          <div class="column is-6 has-text-white is-size-3 is-size-4-mobile" :class="(user == '' || user == null)  && widthMax < 1024 ? 'has-text-centered is-paddingless':''">
            <router-link :to="user =='' ? '/' : '/form/edit'" class="has-text-white" >
              <span class=" has-text-weight-semibold">Great</span>Growth
            </router-link>
          </div>
          <div class="column is-6" v-if="user != '' && user != null">
            <div  class="is-flex is-align-center is-justify-end ">
              <span v-if="user != ''" >
                 <router-link :to="'/invest-list'" class="has-text-white mg-x-3" v-if="user.detailUser[0].investment">Invest</router-link>
              </span>
              <a  v-if="typeof setPercent != 'undefined' && setPercent != null && setPercent == 100" @click="checkisuserticket()" target="_bank" class="has-text-white mg-x-3 ">Ticket</a>
              <span v-if="typeof setPercent != 'undefined' && setPercent != null && setPercent == 100" class="has-text-white mg-x-3">|</span>
              <div class="profilePic mg-x-3 is-hidden-mobile">
                <img v-if="typeof user.detailUser[0] != 'undefined' && user.detailUser[0].profilePic" :src="imgPath + user.detailUser[0].profilePic">
                <img v-else src="@/assets/user.png">
              </div>
              <div class="">
                <b-dropdown aria-role="list" position="is-bottom-left">
                  <p  v-if="typeof user.detailUser[0] != 'undefined'" class="has-text-white cursor th text-capitalize"  slot="trigger"
                role="button">
                      {{user.detailUser[0].name}}&nbsp;&nbsp;<i class="fas fa-chevron-down"></i>
                  </p>
                  <b-dropdown-item @click="$router.push('/form/edit')" aria-role="listitem">You profile</b-dropdown-item>
                  <b-dropdown-item @click="signout()" aria-role="listitem">Sign out</b-dropdown-item>
                </b-dropdown>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <div v-if="pageWhite === false" class="container pd-y-5">
      <slot></slot>
    </div>
    <div :style="widthMax < 1024 ?'margin-top: 130px':''" :class="widthMax < 1024 ?'pd-4':''" v-if="$route.name=='formEditScreen' && typeof setPercent != 'undefined' && setPercent != null && setPercent == 100">
       <div  class="pd-y-5 mg-t-20 container has-text-centered border-ss has-text-success has-background-white">
      <div class="has-text-weight-semibold">
        <p>Thank you! We've recieved your profile and are in the review process.</p>
        <p class="has-text-dark">Now you can gets around to help any businesses and make your profile GreatGrowth together via  <span class="cursor has-text-info" @click="checkisuserticket()">Ticket</span>.
        </p>
      </div>
    </div>
    </div>
   
    <div v-if="pageWhite === true" class="bodyPage container">
      <div class="page-box">
        <slot></slot>
      </div>
    </div>
    <div class="footerPage bg-grey">
      <div class="container has-text-centered ">
         <i class="far fa-copyright"></i>&nbsp;<span class="has-text-weight-semibold">Great</span><span style="font-weight: initial !important;">Growth</span>. All Rights Reserved
      </div>
    </div>
  </div>
</template>
<script>
  import axios from 'axios'
  export default {
   props: {
      pageWhite: {
        type: Boolean,
        default:true
      },
    },
    methods:{
      signout(){
          setTimeout(() => {
            window.localStorage.clear();
          }, 100);
          this.$store.commit("clearlogin");
          window.localStorage.removeItem("vuex");
          this.$router.push("/signin");
      },
      checkisuserticket(){
        let text = JSON.stringify(this.user.detailUser[0])
        let obj = JSON.parse(text)
        obj['userLevel'] = this.user.userLevel
        obj['userId'] = this.user.userId
        obj['typeSystem'] = this.user.typeSystem
        obj['userIdExport'] = this.user.typeSystem == 'inteGreat' ? this.user.detailUser[0].userIdExport : this.user.userId
        obj['projectCode'] = 'oZcIppU-VBIx9KO'
        console.log('obj',obj)
        var jwt = require('jsonwebtoken');
        var secret = 'dFvsdd125ssE'
        var token = jwt.sign({ 
          token:this.user.token,
          obj:obj
         }, secret);
        window.open(this.urlTicket+'token/'+token, '_blank');
        //window.open('http://localhost:8080/token/'+token, '_blank');
      },
    },
    data(){
      return{

       urlTicket:process.env.VUE_APP_BASEURL_TICKET,
        imgPath:process.env.VUE_APP_IMG_PROFILE,
        widthMax: window.innerWidth,
      }
    },
    computed:{
      setPercent(){
        return this.$store.state.setPercent
      },
      beforedataform(){
        return this.$store.state.beforedataform
      },
      dataform(){
        return this.$store.state.senddatamentor
      },
      viewprofile(){
        return this.$store.state.viewprofile
      },
      user(){
        return this.$store.state.islogin
      },
      showTicket(){
        return this.$store.state.showTicket
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style >
.profilePic{
  width: 50px;
  height: 50px;
  overflow: hidden;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
  
}
.profilePic img{
  max-width: 100%;
}
  .scrollPage{
    /* overflow-y:scroll; */
    overflow-x: hidden;
    height: 100%;
  }
  .bodyPage{
    height: 80%;
  }
  .page-box{
    height: 100%;
    overflow-x: hidden;
    background: #fff;
    border-radius: 7px;
    margin:20px 0;
  }
  .page-main{
    padding: 20px;
    min-height: 400px;
  }
  .headPage{
    background-color: #0D6ACA!important;
    padding:5px 0;
    height: 9%;
  }
  .footerPage{
    display: flex;
    align-items: center;
    justify-content: center;
    padding:5px 0;
    height: 7%;
  }
  .border-ss{
    border: 1px solid;
    border-radius: 5px;
  }
 @media screen and (min-width: 100px) and (max-width: 1023px) {
  .headPage{
    height: auto;
  }
  .page-box{
    margin: 60px 0 0 0;
  }
}
</style>
